import { z } from 'zod';
import { RoleSchema } from './auth';
export const FirmSchema = z.object({
    id: z.string(),
    name: z.string(),
    legalName: z.string().nullable(),
    cif: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postalCode: z.string().nullable(),
    province: z.string().nullable(),
    country: z.string(),
    vatRate: z.number(),
    irpfRate: z.number(),
    invoicePrefix: z.string(),
    nextInvoiceNumber: z.number().int(),
    invoiceFootnote: z.string().nullable(),
    bankIban: z.string().nullable(),
    bankBic: z.string().nullable(),
    defaultHourlyRateCents: z.number().int().nonnegative(),
    defaultCurrency: z.string().length(3).default('EUR'),
    defaultLanguage: z.string().length(2).default('es'),
    /** Si es false, los hitos vencidos solo avisan; se facturan a mano. */
    autoInvoiceMilestones: z.boolean(),
    /**
     * F1 — Bloqueo de periodos: fecha tope (YYYY-MM-DD) por debajo de la cual no
     * se pueden crear ni anular asientos. null = sin bloqueo.
     */
    ledgerLockedUntil: z.string().nullable(),
    /**
     * Hoja de gastos: lo que la empresa PAGA por kilometraje y dietas. Los
     * LÍMITES exentos no se configuran —los fija Hacienda y viven en el código—
     * y estas tarifas no pueden superarlos: el exceso es salario y se liquida
     * en nómina.
     */
    mileageRateCents: z.number().int().nonnegative(),
    perDiemNationalCents: z.number().int().nonnegative(),
    perDiemNationalOvernightCents: z.number().int().nonnegative(),
    perDiemAbroadCents: z.number().int().nonnegative(),
    perDiemAbroadOvernightCents: z.number().int().nonnegative(),
    // F14/F15: políticas de seguridad
    enforceMfaRoles: z.array(RoleSchema),
    sessionIdleMinutes: z.number().int().min(5).max(720),
    sessionAbsoluteHours: z.number().int().min(1).max(168),
});
export const UpdateFirmSchema = z.object({
    name: z.string().min(2).max(200).optional(),
    legalName: z.string().max(300).nullable().optional(),
    cif: z.string().max(20).nullable().optional(),
    email: z
        .union([z.string().email(), z.literal('')])
        .nullable()
        .optional(),
    phone: z.string().max(30).nullable().optional(),
    address: z.string().max(300).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    postalCode: z.string().max(10).nullable().optional(),
    province: z.string().max(100).nullable().optional(),
    country: z.string().length(2).optional(),
    vatRate: z.number().min(0).max(100).optional(),
    irpfRate: z.number().min(0).max(100).optional(),
    invoicePrefix: z.string().max(10).optional(),
    invoiceFootnote: z.string().max(1000).nullable().optional(),
    bankIban: z.string().max(40).nullable().optional(),
    bankBic: z.string().max(20).nullable().optional(),
    defaultHourlyRateCents: z.number().int().nonnegative().optional(),
    defaultCurrency: z.string().length(3).default('EUR'),
    defaultLanguage: z.string().length(2).default('es'),
    autoInvoiceMilestones: z.boolean().optional(),
    /** F1 — fecha tope de bloqueo contable (YYYY-MM-DD) o null para quitarlo. */
    ledgerLockedUntil: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
    /** Hoja de gastos: tarifas de la empresa. Topadas por el límite legal exento. */
    mileageRateCents: z.number().int().min(0).max(26).optional(),
    perDiemNationalCents: z.number().int().min(0).max(2667).optional(),
    perDiemNationalOvernightCents: z.number().int().min(0).max(5334).optional(),
    perDiemAbroadCents: z.number().int().min(0).max(4808).optional(),
    perDiemAbroadOvernightCents: z.number().int().min(0).max(9135).optional(),
    // F15.3 — políticas de seguridad
    enforceMfaRoles: z.array(RoleSchema).optional(),
    sessionIdleMinutes: z.number().int().min(5).max(720).optional(),
    sessionAbsoluteHours: z.number().int().min(1).max(168).optional(),
});
export const UpdateProfileSchema = z.object({
    fullName: z.string().min(2).max(200).optional(),
    /** F40 — Idioma preferido del usuario. */
    locale: z.enum(['ES', 'EN', 'PT']).optional(),
});
//# sourceMappingURL=firm.js.map